<template>
  <div id="summary" class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="confirm(false)"><span class="blind">close</span></button>
      <h1 class="notranslate">{{locale.summary_title}}</h1>
      <h2 class="room notranslate">{{room}}</h2>
      <div class="submitAt notranslate">{{submitAt}}</div>
      <div class="summaryList">
        <div class="item"
          v-for="amenity in summary.items"
          :key="amenity.item">
          <span class="thumb"><img :src="src(amenity.item)" alt="" /></span>
          <span class="name" v-html="getItemName(amenity)"></span>
          <div class="count notranslate">
            <span v-if="amenity.price" class="price">{{priceFormat(amenity.price)}}</span>
            <span class="colorGrey">({{amenity.count}})</span>
          </div>
          <div v-if="amenity.price" class="total">{{priceFormat(amenity.price * amenity.count)}}</div>
        </div>
      </div>
      <div v-if="price" class="summaryItem notranslate">
        <div class="priceInfo">
          <!-- tax -->
          <div v-if="price.info.tax" class="tax">
            <div class="calculate row">
              <span class="label">{{locale.subtotal}}</span>
              <span class="value price">{{priceFormat(price.info.subtotal)}}</span>
            </div>
            <div class="calculate row">
              <span class="label">{{locale.tax}}({{price.info.taxLabel}})</span>
              <span class="value price">{{priceFormat(price.info.tax)}}</span>
            </div>
          </div>
          <!-- //tax -->
          <div class="calculate row">
            <span class="label">{{locale.total}}</span>
            <span class="value price">{{priceFormat(price.info.total)}}</span>
          </div>
        </div>
      </div>
      <div v-if="isCart" class="btns notranslate">
        <button
          type="button"
          class="btn toCapitalize"
          @click.stop="confirm('cart')">
          {{locale.cart}}
        </button>
        <!-- <button type="button" class="btn btnWhite" @click.stop="confirm(false)">{{locale.cancel}}</button> -->
        <button
          type="button"
          class="btn btnWhite toCapitalize"
          @click.stop="confirm('request')">{{locale.btn_request}}</button>
      </div>
      <div v-else class="btns notranslate">
        <button type="button" class="btn btnWhite" @click.stop="confirm(false)">{{locale.cancel}}</button>
        <button
          type="button"
          class="btn toCapitalize"
          @click.stop="confirm('request')">{{locale.btn_request}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import regExp from '@/common/regExp'

export default {
  name: 'Summary',
  props: [
    'lang',
    'locale',
    'localeAmenity',
    'roomKey',
    'summary',
    'requestPossible',
    'price'
  ],
  computed: {
    room () {
      return `ROOM ${this.$store.state.authentication.space}`
    },
    siteCommon () {
      return this.$store.getters['common/getSetting']
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    submitAt: {
      get () {
        const submitAt = DateTime.fromISO(this.summary.submitAt)
        return submitAt.toFormat(this.format)
      },
      set (sa) {
        // console.log(sa)
      }
    },
    isCart () {
      const setting = this.$store.getters['amenity/getAmenitySetting']
      return setting && setting.cart !== false
    }
  },
  methods: {
    src (amenityItem) {
      return `${process.env.BASE_URL}img/amenity/${amenityItem.toLowerCase()}.png`
    },
    priceFormat (price) {
      const code = this.siteCommon.currency.toUpperCase()
      return regExp.priceFormat(price, code)
    },
    getItemName (item) {
      const lang = this.$route.params.ln
      const itemName = `amenity_${item.item.toLowerCase()}`
      return item.label ? item.label[lang] : this.localeAmenity[itemName]
    },
    confirm (isConfirm) {
      this.$emit('confirm', isConfirm)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  font-size: 14px;
}
.room {
  margin-top: 0.5em;
  margin-bottom: 2px;
  padding-bottom: 0.2em;
  text-align: center;
  font-size: 1.6em;
  font-weight: 700;
  border-bottom: 4px solid $color-dark;
}
.submitAt {
  margin-bottom: 1.2em;
  padding-top: 0.2em;
  font-size: 0.85em;
  color: $color-grey;
  border-top: 1px solid $color-dark;
}
.summaryList {
  border-top: 1px solid $color-lgrey;
  border-bottom: 1px solid $color-lgrey;
  .item {
    display: flex;
    align-items: center;
    position: relative;
    padding: 1em 0;
    img {
      width: 32px;
      margin-right: 0.5em;
    }
    .name {
      margin-left: 0.5em;
    }
    .price {
      display: inline-block;
      position: relative;
      margin-right: 2px;
      padding: 2px 4px 2px 12px;
      font-size: 0.85em;
      border-radius: 4px;
      border: 1px solid $color-lgrey2;
      background-color: rgba($color-lgrey2, 0.25);
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 3px;
        height: 3px;
        margin-top: -3px;
        margin-left: 2px;
        border-radius: 100%;
        border: 1px solid $color-lgrey2;
        background-color: $color-grey;
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: -4px;
        width: 8px;
        margin-top: -1px;
        border-top: 1px solid $color-lgrey;
      }
    }
    .count {
      margin-left: 0.5em;
    }
    .total {
      margin-left: auto;
    }
    &+.item {
      border-top: 1px dashed $color-lgrey;
    }
  }
}
.priceInfo {
  margin-top: 15px;
  font-size: 1.2em;
  font-weight: bold;
  .calculate {
    display: flex;
    .value {
      margin-left: auto;
    }
  }
  .tax {
    font-size: 0.85em;
    font-weight: normal;
  }
}
.message {
  margin-top: 30px;
  margin-bottom: -20px;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 8px;
  color: $color-white;
  background-color: $color-red;
  & + .message {
    margin-top: 25px;
  }
}
</style>
